// extracted by mini-css-extract-plugin
export var drawerContent = "_3m-0";
export var valueBlock = "_3m-1";
export var valueBlockFrom = "_3m-2 _3m-1";
export var valueBlockTo = "_3m-3 _3m-1";